/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalReauthSubmissionListEntryPayer
 */
export interface PalReauthSubmissionListEntryPayer {
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    insurance_type?: string;
}

/**
 * Check if a given object implements the PalReauthSubmissionListEntryPayer interface.
 */
export function instanceOfPalReauthSubmissionListEntryPayer(value: object): value is PalReauthSubmissionListEntryPayer {
    return true;
}

export function PalReauthSubmissionListEntryPayerFromJSON(json: any): PalReauthSubmissionListEntryPayer {
    return PalReauthSubmissionListEntryPayerFromJSONTyped(json, false);
}

export function PalReauthSubmissionListEntryPayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmissionListEntryPayer {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'insurance_type': json['insurance_type'] == null ? undefined : json['insurance_type'],
    };
}

export function PalReauthSubmissionListEntryPayerToJSON(json: any): PalReauthSubmissionListEntryPayer {
    return PalReauthSubmissionListEntryPayerToJSONTyped(json, false);
}

export function PalReauthSubmissionListEntryPayerToJSONTyped(value?: PalReauthSubmissionListEntryPayer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'insurance_type': value['insurance_type'],
    };
}

